import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class EmailValidationService {
    static checkEmailVerified_Ext(account, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('quote'),
            'checkEmailVerified_Ext', [account], additionalHeaders);
    }
}
